// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
	console.log("Item added to the cart");
	console.log(evt.detail.product);
}); // This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener("cart:updated", function (evt) {
	console.log("Cart updated");
	console.log(evt.detail.cart);
}); // This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.

document.addEventListener("cart:error", function (evt) {
	console.log("Cart error");
	console.log(evt.detail.errorMessage);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener("quick-cart:open", function (evt) {
	console.log("Quick cart opened");
	console.log(evt.detail.cart);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.

document.addEventListener("quick-cart:close", function () {
	console.log("Quick cart closed");
}); // This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.

document.addEventListener("product:variant-change", function (evt) {
	console.log("Product variant changed");
	console.log(evt.detail.variant);
}); // This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.

document.addEventListener("product:quantity-update", function (evt) {
	console.log("Product quantity updated");
	console.log(evt.detail.quantity, evt.detail.variant);
}); // This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.

document.addEventListener("quickview:loaded", function () {
	console.log("Quickview loaded");
});
// ---------------------------------------------------------------------
// code for collection ATC buttons
//v2
// Function to attach event listeners to .frequency elements
function attachFrequencyListeners() {
	var frequencyItems = document.querySelectorAll(".subscription-option");
	// Loop through all .subscription-option elements and attach event listeners
	frequencyItems.forEach(function (frequencyItem) {
		// Check if the event listener has already been attached
		if (!frequencyItem.dataset.listenerAttached) {
			frequencyItem.addEventListener("click", handleFrequencyChange);

			// Mark this .subscription-option element as having an event listener attached
			frequencyItem.dataset.listenerAttached = "true";
		}
	});
}

function handleFrequencyChange(event) {
	// Get variantId from the clicked li's parent ul's data-variant-id attribute
	var variantId = event.currentTarget.parentNode.getAttribute("data-variant-id");
	console.log("variantID", variantId);

	// Get the clicked li element
	var selectedOption = event.currentTarget;

	// Retrieve the value of the 'data-selling-plan-id' attribute from the clicked li
	var sellingPlan = selectedOption.getAttribute("data-selling-plan-id");

	console.log("before send", variantId, 1, sellingPlan);
	addItemToCart(variantId, 1, sellingPlan);
}

// ... rest of your existing JavaScript code remains unchanged

function addItemToCart(variant_id, qty, selling_plan) {
	var data = {
		id: variant_id,
		quantity: qty,
		selling_plan: selling_plan,
	};
	jQuery.ajax({
		type: "POST",
		url: "/cart/add.js",
		data: data,
		dataType: "json",
		success: function () {
			console.log("subscription product added to cart");
		},
	});
}
//function to attach quick add to cart button listener
function attachQuickAtcListeners() {
	$("#quick-atc-form").on("submit", function (event) {
		event.preventDefault(); // prevent default form submission
		$.ajax({
			type: "POST",
			url: "/cart/add.js",
			data: $(this).serialize(),
			dataType: "json",
			success: function () {
				console.log("Added product to cart");
			},
			error: function () {
				console.log("error adding product to cart");
			},
		});
	});
}

// Initially, attach event listeners
document.addEventListener("DOMContentLoaded", function () {
	attachFrequencyListeners();
	attachQuickAtcListeners();
});

// ------------------------- collection select container open/close
document.addEventListener("DOMContentLoaded", function () {
	const selectContainers = document.querySelectorAll(".select-container");

	selectContainers.forEach(function (container) {
		const dropdownButton = container.querySelector("button");
		const dropdown = container.querySelector(".subscription-dropdown");

		dropdownButton.addEventListener("click", function (event) {
			const isExpanded = dropdown.classList.toggle("active");
			dropdownButton.setAttribute("aria-expanded", isExpanded);
			event.stopPropagation(); // Prevent this click from being detected by the click event listener on the document below
		});
	});

	// Add a click event listener to the document
	document.addEventListener("click", function () {
		// Hide all dropdowns when a click happens outside the dropdown
		closeAllDropdowns();
	});
});

function closeAllDropdowns() {
	const allDropdowns = document.querySelectorAll(".subscription-dropdown");

	allDropdowns.forEach(function (dropdown) {
		dropdown.classList.remove("active");
		const button = dropdown.closest(".select-container").querySelector("button");
		button.setAttribute("aria-expanded", "false");
	});
}

// ---------------------------------------------
// mutation event listener
// Find the collection container element
// Select the target node
const collectionContainer = document.querySelector(".collection__loading");

if (collectionContainer) {
	// Options for the observer (which mutations to observe)
	const options = {
		attributes: true,
	};

	function callbackFunction(mutationList, observer) {
		mutationList.forEach(function (mutation) {
			if (mutation.type === "attributes" && mutation.attributeName === "class") {
				if (!collectionContainer.classList.contains("is-active")) {
					// Your existing function calls
					attachFrequencyListeners();
					attachQuickAtcListeners();

					// Now, initialize the dropdown scripts after the specific mutation is detected
					initializeDropdownScripts();
				}
			}
		});
	}

	// Create an observer instance linked to the callback function
	const observer = new MutationObserver(callbackFunction);
	observer.observe(collectionContainer, options);
} else {
	console.log("collectionContainer not found. Mutation observer not initiated.");
}

function initializeDropdownScripts() {
	const selectContainers = document.querySelectorAll(".select-container");

	selectContainers.forEach(function (container) {
		const dropdownButton = container.querySelector("button");
		const dropdown = container.querySelector(".subscription-dropdown");

		dropdownButton.addEventListener("click", function (event) {
			const isExpanded = dropdown.classList.toggle("active");
			dropdownButton.setAttribute("aria-expanded", isExpanded);
			event.stopPropagation(); // Prevent this click from being detected by the click event listener on the document below
		});
	});

	// Add a click event listener to the document
	document.addEventListener("click", function () {
		// Hide all dropdowns when a click happens outside the dropdown
		closeAllDropdowns();
	});
}

// ----------------------------------------------------------------
// ADA compliance
// When modal is opened
document.getElementById("search").focus();

// When modal is closed
//below causing problems
// triggeringElement.focus();
// Get the cart element

const cart = document.querySelector(".quick-cart__wrapper");

// Create a MutationObserver instance
const observer = new MutationObserver(function (mutations) {
	mutations.forEach(function (mutation) {
		if (mutation.type === "attributes" && mutation.attributeName === "class") {
			// Check if the 'active' class is present
			if (cart.classList.contains("active")) {
				// If 'active' class is present, set 'aria-hidden' to 'false'
				cart.setAttribute("aria-hidden", "false");
			} else {
				// If 'active' class is not present, set 'aria-hidden' to 'true'
				cart.setAttribute("aria-hidden", "true");
			}
		}
	});
});

// Configuration of the observer
const config = { attributes: true, childList: false, characterData: false };

// Pass in the target node (cart), as well as the observer options (config)
// observer.observe(cart, config);
